import apiService from "../../../../../services/api";

export const getCreditHistory = async (params: {
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params.startDate) queryParams.append("start_date", params.startDate);
  if (params.endDate) queryParams.append("end_date", params.endDate);

  if (params.limit !== undefined)
    queryParams.append("limit", params.limit.toString());
  if (params.offset !== undefined)
    queryParams.append("offset", params.offset.toString());

  const queryString = queryParams.toString();
  const url = `/billing/credits/history?${queryParams.toString()}`;
  return await apiService.get(url);
};

export const getCreditBalance = async () => {
  const url = `/billing/credits`;
  return await apiService.get(url);
};
export const getTrailStatus = async () => {
  const url = `/billing/trial-status`;
  return await apiService.get(url);
};
